import _ from 'lodash'
import { gql } from 'graphql-request'
import { createQuery, buildPaginatedResponse } from '@fivehealth/botero'

const GRAPHQL_DOCUMENT = gql`
  query allProfilesGroups(
    $sortBy: ProfilesGroupOrderBy
    $sortDesc: Boolean
    $name: String
  ) {
    einsteinProfilesGroups(
      sortBy: $sortBy
      sortDesc: $sortDesc
      name_Icontains: $name
    ) {
      edges {
        node {
          uid
          name
          ruleset {
            directoryProfiles {
              uid
            }
            uid
            name
          }
        }
      }
      totalCount
    }
  }
`

export default createQuery({
  gqlDocument: GRAPHQL_DOCUMENT,
  queryType: 'query',
  baseQueryKey: 'allProfilesGroup',
  paginate: 'offset',
  select: (data) => buildPaginatedResponse(data, 'einsteinProfilesGroups'),
  getNextPageParam: ({ einsteinProfilesGroups: data } = {}, allPages) => {
    const hasNextPage = _.get(data, 'pageInfo.hasNextPage', false)
    if (!hasNextPage) {
      return undefined
    }
    const currentOffset = allPages.flatMap(({ einsteinProfilesGroups }) =>
      _.get(einsteinProfilesGroups, 'edges', [])
    ).length
    return currentOffset
  },
  keepPreviousData: true,
})
